import { render, staticRenderFns } from "./ValueMobileSection.vue?vue&type=template&id=8eae2a04&scoped=true&"
import script from "./ValueMobileSection.vue?vue&type=script&lang=js&"
export * from "./ValueMobileSection.vue?vue&type=script&lang=js&"
import style0 from "./ValueMobileSection.vue?vue&type=style&index=0&id=8eae2a04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eae2a04",
  null
  
)

export default component.exports